import header from './_header';
import footer from './_footer';

const data = [
  { ...header },
  {
    type: 'ReunionForm',
  },
  { ...footer },
];

export default data;
